import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createPalletPostcodePricing({ commit }, item) {
    return this.$axios.$post('admin/palletPostcodePricing/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removePalletPostcodePricing({ commit }, item) {
    return this.$axios.$delete(`admin/palletPostcodePricing/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updatePalletPostcodePricing({ commit }, item) {
    return this.$axios.$put(`admin/palletPostcodePricing/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchPalletPostcodePricing({ commit }, id) {
    return this.$axios.$get(`admin/palletPostcodePricing/${id}`).then((response) => {
      return response.data
    })
  },
  fetchPalletPostcodePricings({ commit }, params = {}) {
    return this.$axios.$get('admin/palletPostcodePricing', { params }).then((response) => {
      commit('load', response.data)
      return response
    })
  },
  importCsv({ commit }, dataUrl) {
    return this.$axios.$post('admin/import/palletPostcodePricing', { file: dataUrl }).then((response) => response)
  },
  exportCsv() {
    return this.$axios.$get('admin/export/palletPostcodePricing', { responseType: 'blob' })
  },
}
